const riot = require('riot');

riot.tag2('module-sms-verification', '<div class="px24 pt32"> <div class="ts-hl text-gray_80 text-center mb24">ご本人確認</div> <div if="{step === &quot;phone&quot;}"> <div class="ts-ps text-gray_80 mb24">不正な利用を防ぐため、ご本人確認としてSMS認証を行っております。<br>認証コードを送付可能な携帯電話番号を入力し「送信」ボタンを押してください。</div> <form onsubmit="{sendOtp}"> <input class="input w-full mb24" type="tel" inputmode="numeric" autocomplete="tel" aria-label="電話番号" placeholder="例）080XXXXXXXX" riot-value="{phoneNumber}" oninput="{onInputPhone}"> <div class="ts-pxs text-gray_80 mb4">※ハイフンなし、半角数字で入力してください</div> <div class="ts-pxs text-gray_80 mb4">※070, 080, 090から始まる番号のみご利用いただけます</div> <div class="ts-pxs text-gray_80 mb24">※送信ボタンを押すことで、SMS認証および<a class="text-link" href="/campaigns/{opts.event.campaign_id}/terms">個人情報の取り扱い</a>に同意したものとみなします</div> <button class="button size-l primary w-full mb24" disabled="{!isValidPhone()}">送信</button> </form> <div class="ts-pxs text-error mb24" if="{errorMessage}">{errorMessage}</div> </div> <div if="{step === &quot;otp&quot;}"> <div class="ts-ps text-gray_80 mb24">SMS を送信しました。<br>SMS に記載の認証コードを以下のフォームに入力し、確認ボタンを押してください。</div> <form onsubmit="{verifyOtp}"> <input class="input w-full mb24" type="text" inputmode="numeric" maxlength="6" autocomplete="one-time-code" placeholder="認証コード" riot-value="{otpCode}" oninput="{onInputOtp}"> <div class="ts-pxs text-gray_80 mb24">※認証コードの有効期限は2分間です。届かない場合や無効になった場合は再送信してください</div> <button class="button size-l primary w-full mb16" disabled="{!isValidOtp()}">確認</button> </form> <div class="f fh mb24"> <button class="resend-link ts-ps" if="{canResend()}" type="button" onclick="{resendOtp}">認証コードを再送信</button><span class="text-black opacity-50 ts-ps" if="{!canResend()}">認証コードの再送信まで（{countdownRemaining}秒）</span> </div> <div class="ts-pxs text-error mb24" if="{errorMessage}">{errorMessage}</div> </div> </div>', 'module-sms-verification,[data-is="module-sms-verification"]{display:block} module-sms-verification .resend-link,[data-is="module-sms-verification"] .resend-link{padding:0;border:none;background:transparent;color:var(--color-link);font-family:inherit;cursor:pointer}', 'class="w-full"', function(opts) {
    this.step = 'phone';
    this.phoneNumber = '';
    this.otpCode = '';
    this.verificationId = '';

    this.resendAvailableAt = 0;
    this.countdownRemaining = 0;
    this.errorMessage = '';

    var countdown_timer = null;

    this.normalizeNumericInput = (value) => {
      return (value || '')
        .replace(/[０-９]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xFEE0))
        .replace(/[-ー－\s　]/g, '');
    };

    this.isValidPhone = () => {
      return /^0[789]0\d{8}$/.test(this.normalizeNumericInput(this.phoneNumber));
    };

    this.isValidOtp = () => {
      return /^\d{6}$/.test(this.normalizeNumericInput(this.otpCode));
    };

    this.canResend = () => {
      return this.countdownRemaining <= 0;
    };

    this.onInputPhone = (e) => {
      this.phoneNumber = e.target.value;
    };

    this.onInputOtp = (e) => {
      this.otpCode = e.target.value;
    };

    this.startCountdown = () => {
      this.stopCountdown();
      var tick = () => {
        var remaining = Math.ceil((this.resendAvailableAt - Date.now()) / 1000);
        this.countdownRemaining = remaining > 0 ? remaining : 0;
        if (this.countdownRemaining <= 0) {
          this.stopCountdown();
        }
        this.update();
      };
      tick();
      countdown_timer = setInterval(tick, 1000);
    };

    this.stopCountdown = () => {
      if (countdown_timer) {
        clearInterval(countdown_timer);
        countdown_timer = null;
      }
    };

    this.sendOtp = async (e) => {
      e.preventDefault();
      if (!this.isValidPhone()) return;
      this.errorMessage = '';
      var indicator = spat.modal.indicator();
      try {
        var res = await app.api.child('distribution_events:sendSmsOtp').post({
          onetime_hash: this.opts.onetimeHash,
          phone_number: this.normalizeNumericInput(this.phoneNumber),
        });
        this.verificationId = res.verification_id;
        this.resendAvailableAt = Number(res.resend_available_at);
        this.otpCode = '';
        this.step = 'otp';

        this.startCountdown();
      }
      catch (err) {
        console.error(err?.status, err?.message);
        this.errorMessage = this.sendErrorMessage(err);
        this.update();
      }
      finally {
        indicator.close();
      }
    };

    this.resendOtp = async () => {
      if (!this.canResend()) return;
      this.errorMessage = '';
      var indicator = spat.modal.indicator();
      try {
        var res = await app.api.child('distribution_events:resendSmsOtp').post({
          onetime_hash: this.opts.onetimeHash,
          verification_id: this.verificationId,
          phone_number: this.normalizeNumericInput(this.phoneNumber),
        });
        this.verificationId = res.verification_id;
        this.resendAvailableAt = Number(res.resend_available_at);
        this.otpCode = '';

        this.startCountdown();
      }
      catch (err) {
        console.error(err?.status, err?.message);
        this.errorMessage = this.sendErrorMessage(err);
        this.update();
      }
      finally {
        indicator.close();
      }
    };

    this.verifyOtp = async (e) => {
      e.preventDefault();
      if (!this.isValidOtp()) return;
      this.errorMessage = '';
      var indicator = spat.modal.indicator();
      try {
        await app.api.child('distribution_events:verifySmsOtp').post({
          onetime_hash: this.opts.onetimeHash,
          verification_id: this.verificationId,
          otp_code: this.normalizeNumericInput(this.otpCode),
        });
        this.stopCountdown();

        this.trigger('verified');
      }
      catch (err) {
        console.error(err?.status, err?.message);
        this.errorMessage = this.verifyErrorMessage(err);
        this.update();
      }
      finally {
        indicator.close();
      }
    };

    this.sendErrorMessage = (err) => {
      if (err?.status === 409) {
        return 'このキャンペーンは、入力された電話番号ですでに特典を受け取り済みです。';
      }
      if (err?.status === 429) {
        return '認証コードの送信回数が上限に達したか、短時間に送信されています。しばらく時間をおいてからお試しください。';
      }
      return '送信に失敗しました。';
    };

    this.verifyErrorMessage = (err) => {
      if (err?.status === 409) {
        return 'このキャンペーンは、入力された電話番号ですでに特典を受け取り済みです。';
      }
      return '認証に失敗しました。「確認」ボタン下にある「認証コードを再送信」を押して、再度受信した認証コードをご入力ください。';
    };

    this.on('unmount', () => {
      this.stopCountdown();
    });
});